import definitions from './constants'

export const getEntityType = (typeCd) => {
    const {
        entityTypes: { company, entrepreneur, person },
        entityNames: { COMPANY, ENTREPRENEUR, PERSON, GROUP },
    } = definitions

    if (company.indexOf(typeCd) !== -1) return COMPANY
    if (entrepreneur.indexOf(typeCd) !== -1) return ENTREPRENEUR
    if (person.indexOf(typeCd) !== -1) return PERSON

    return GROUP
}
